import React from "react";
import Typography from "@material-ui/core/Typography";
import {
    avanceResources,
    diferenciasResources,
    forzadosResources,
    inventarioResources,
    tagResources,
    validacionWalmart
} from "../endpoints";
import useToken from "../useToken";
import Grid from "@material-ui/core/Grid";
import {Autocomplete} from "@material-ui/lab";
import TextField from "@material-ui/core/TextField";
import {Link, withRouter} from "react-router-dom";
import {Tooltip} from "@material-ui/core";
import AddIcon from '@material-ui/icons/Add';
import IconButton from "@material-ui/core/IconButton";
import SnackbarAlert from "../components/SnackbarAlert";
import TablaAvanceVirtualizada from "../components/TablaAvanceVirtualizada";
import Button from "@material-ui/core/Button";
import SvgIcon from "@material-ui/core/SvgIcon";
import DialogExportar from "../components/DialogExportar";
import DialogAuditoriaEstandar from "../components/DialogAuditoriaEstandar";
import DialogCheckList from "../components/DialogCheckList";
import DashboardAvance from "../components/DashboardAvance";
import DialogCargarArchivos from "../components/DialogCargarArchivos";
import { Redirect } from "react-router-dom";

class Avance extends React.Component {
    constructor(props) {
        super(props);
        this.state={
            datos: [],
            disponibles:[],
            inv_elegido:null,
            openSnack: false,
            severity: '',
            message: '',
            existen_forzados: false,
            existen_duplicados: false,
            error_timestamp:false,
            open_check_list: false,
            open_auditoria: false,
            open: false,
            loading:true,
            tipo_inv: "SIN TEÓRICO",
            inicio_inv:'',
            openCargarArchivos: false,
            verifica_correo_tienda:false,
        }
    }
    handleClose = () => {
        this.setState({open: false, open_auditoria: false, open_check_list: false, openCargarArchivos:false})
    }

    refrescar =(estado,severity) =>{
        this.setState({ openCargarArchivos:false,open_auditoria: false, openSnack: false, open_check_list:false, open_caminado_tickets: false, open: false})
        if (severity){
            this.setState({
                open: false,
                openSnack: true,
                message: estado,
                severity: severity})
        }
    }
    
    verificaCorreoTienda= (folio) => {
            inventarioResources.verificaCorreoTienda(folio).then(async response =>{
            if (response){
                return await response.json();
            }
            }).then(data => {
                this.setState({verifica_correo_tienda:data})
            }).catch(error=> {
                console.error(error);
            });
        };

    obtenerInvDisponibles = () =>{
        this.setState({openSnack:false, severity: null, message:null})
        inventarioResources.getInvDisponibles().then(async response => {
            if (response) {
                return await response.json();
            }
        }).then(data => {
            if(data.status_code === 200){
                this.setState({disponibles:data.inv_disponibles}, ()=>{
                    let datos_inv = useToken.getDatos()
                    let index = data.inv_disponibles.findIndex(e => String(e.folio) === String(datos_inv.folio));
                    if(index !== -1){
                        this.setState({inv_elegido:this.state.disponibles[index]})
                    }
                })


            }
            else if (data.status_code === 401){
                this.setState({openSnack:true, severity:data.severity, message:data.message})
            }
            else{
                throw new Error('Something went wrong ...');
            }
        }).catch(error=> {
            console.error(error);
        });
    }

    cambiarInv = (newValue) => {
        this.setState({ openSnack: false, severity: null, message: null });

        const { folio, id_cliente } = newValue;

        inventarioResources.cambiarInv(folio, id_cliente)
            .then(async response => response && await response.json())
            .then(result => {
                if (!result?.message) {
                    throw new Error("Respuesta inválida");
                }

                const token = result.access_token;

                if (token) {
                    // 🔥 ESTE ES EL CAMBIO CLAVE
                    useToken.setToken(token, newValue);

                    this.setState({
                        openSnack: true,
                        severity: result.severity,
                        message: result.message,
                        inv_elegido: newValue
                    }, () => {
                        this.obtenerDatos();
                        this.diferenciaGeneral();

                        const datos_inv = useToken.getDatos();
                        this.setState({
                            cliente: datos_inv.app,
                            estado_inv: datos_inv.estado
                        });
                    });

                    // ❌ NO navegar
                    // this.props.history.push(this);
                } else {
                    this.setState({
                        openSnack: true,
                        severity: result.severity,
                        message: result.message,
                    });
                }
            })
            .catch(error => {
                console.error(error);
                this.setState({
                    openSnack: true,
                    severity: 'error',
                    message: "Error al cambiar el inventario actual"
                });
            });
    };

    obtenerDatos =()=>{
        this.setState({openSnack:false, severity: null, message:null})
        avanceResources.getAvanceUbicacion().then(async response => {
            if (response) {
                return await response.json();
            }
        }).then(result => {
            if(result.status_code === 200){
                this.setState({datos:result.avance})
            }
            else if (result.status_code === 401){
                this.setState({openSnack:true, severity:result.severity, message:result.message})
            }
            else{
                throw new Error('Something went wrong ...');
            }
        }).catch(error=> {
            console.log(error)
        });
    };

    existen_forzados = () =>{
        forzadosResources.existenForzados().then(async response => {
            if (response.ok) {
                return await response.json();
            } else {
                throw new Error('Something went wrong ...');
            }
        }).then(result => {
            if(result === 0){
                this.setState({existen_forzados:false})
            }
            else if(result > 0){
                this.setState({existen_forzados:true})
            }
        }).catch(error=> {
            console.log(error)
        });
    }

    verificaTimestamp = ()=>{
        validacionWalmart.verificaiconTimestampWalmart().then(async response =>{
            if (response.ok) {
                return await response.json();
            } else {
                throw new Error('Something went wrong ...');
            }
        }).then(result => {
            if(result > 0){
                this.setState({error_timestamp:true})
            }
        }).catch(error=> {
            console.log(error)
        });
    }

    existenDuplicados = ()=>{
        tagResources.existenDuplicados().then(async response =>{
            if (response.ok) {
                return await response.json();
            } else {
                throw new Error('Something went wrong ...');
            }
        }).then(result => {
            if(result === 0){
                this.setState({existen_duplicados:false})
            }
            else if(result > 0){
                this.setState({existen_duplicados:true})
            }
        }).catch(error=> {
            console.log(error)
        });
    }

    componentDidMount() {
        const verifyFolio = useToken.verifyToken()
        if(!verifyFolio){
            this.props.history.push('/inventarios');
        }
        else{
            this.obtenerDatos();
            this.diferenciaGeneral();
            this.obtenerInvDisponibles();
            this.existen_forzados()
            this.existenDuplicados()
            this.verificaTimestamp()
            let datos_inv = useToken.getDatos()
            this.setState({cliente:datos_inv.app, estado_inv:datos_inv.estado, rowData:{folio:datos_inv.folio}})
      
            if (datos_inv.app === 'smu_perecible'){
                this.verificaCorreoTienda(datos_inv.folio);
            }
            
        }

    };

    diferenciaGeneral = () => {
        diferenciasResources.getDiferenciaGeneral().then(async (response) => {
            if (response) {
                return await response.json();
            }
            throw new Error("No response");
        })
            .then((result) => {
                if (result.status_code === 200) {
                    this.setState({
                        datos_diferencia : {
                            unidades_contadas: result.diferencia.inv ,
                            unidades_teoricas: result.diferencia.teo,
                            imp_contado: result.diferencia.invimp,
                            imp_teorico: result.diferencia.teoimp,
                            diferencia_unidades: result.diferencia.dif ,
                            diferencia_valorizado: result.diferencia.difimp,
                            hora_inicio: result.diferencia.timestamp
                        },
                        tipo_inv: result.diferencia.teo !== 0 && result.diferencia.teo !== null  ?  "CON TEÓRICO" : "SIN TEÓRICO",
                        loading: false,
                    });
                } else {
                    this.setState({ loading: false });
                    throw new Error("Something went wrong ...");
                }
            })
            .catch((error) => {
                console.error(error);
                this.setState({ loading: false });
            });
    };

    enviarDatosReportes =(nombre)=>{
        let params = ""
        let padres = []
        let reporte = ""
        let origen  = ""

        if (nombre === 'revision_tag_operador'){
            origen = "revision_tag_operador"
            if(this.state.factor === true && this.state.sin_factor === false){
                reporte = "tag_detalle_factor"
            }
            else if (this.state.factor === false && this.state.sin_factor === true){
                reporte = "tag_detalle"
            }
        }
        else if (nombre === 'high_dollar' || nombre ==='high_dollar_bodega' || nombre === 'low_dollar' || nombre ==='low_dollar_bodega'){
            origen = "otro"
            reporte = nombre+ '_' +this.state.cliente
        }
        else{
            origen = "otro"
            reporte = nombre
        }
        if(reporte === "tags_pendientes" || reporte === "tags_nulos"){
            const datos = this.state.datos
            datos.forEach(element => {
                if (element.padre === null){
                    padres.push(element)
                }
            });
            padres.forEach(element => {
                if (padres.indexOf(element) === 0) {
                    params = params + element.id
                } else {
                    params = params + "," + element.id
                }
            });
        }
        this.setState({open: true, reporte: reporte, params: params,openSnack:false, origen:origen})
    }


    render() {
        const verifyFolio = useToken.verifyToken()

        if(!verifyFolio){
            return <Redirect to="/inventarios"/>
        }
        else{
            return(
                <div>
                    <Typography variant="h4" gutterBottom>
                        Avance
                    </Typography>
                    <Grid container direction="row" justifyContent="flex-end" alignItems="center" spacing={2} style={{padding:10, marginBottom:10}}>
                        <Grid item xs={3}>
                            <Autocomplete
                                style={{ width: "auto" }}
                                id="size-small-standard"
                                onChange={(event, newValue) => {
                                    if(newValue === null) {
                                        this.setState({inv_elegido: null})
                                    }
                                    else{
                                    this.cambiarInv(newValue)
                                    }
                                }}
                                value={this.state.inv_elegido}
                                options={this.state.disponibles}
                                noOptionsText={"No hay opciones"}
                                getOptionLabel={(option) => option.folio + "-" + option.centro_descripcion || ""}
                                renderInput={(params) => (
                                    <TextField {...params} variant="standard" label="Cambiar inventario" placeholder="Inventarios disponibles" />
                                )}
                            />
                        </Grid>

                        <Grid item xs={"auto"}>
                            <Link to={"/agregar_inv"} style={{color: '#000000', textDecoration: 'none'}}>
                                <Tooltip title={"Agregar inventario"}>
                                    <IconButton style={{backgroundColor:"#3EB415", color:"#FFFFFF"}} size="small">
                                        <AddIcon/>
                                    </IconButton>
                                </Tooltip>
                            </Link>
                        </Grid>
                    </Grid>
                    <br/>
                    <DashboardAvance datos={this.state.datos}  datos_diferencia={this.state.datos_diferencia}
                                    tipo_inv={this.state.tipo_inv} estado_inv={this.state.estado_inv} loading={this.state.loading}/>
                    <br/>
                    <Grid container direction="row" justifyContent="flex-end" alignItems="center" spacing={2} style={{padding:10, marginBottom:10}}>
                        {this.state.cliente !== 'smu_perecible' &&
                            <>
                                <Grid item>
                                    <Link to={"/tags_avance/negativos/0/null"} target="_blank" rel="noreferrer" style={{color: '#000000', textDecoration: 'none'}}>
                                        <Button variant="contained" color="primary">
                                            Ver negativos
                                        </Button>
                                    </Link>
                                </Grid>
                                <Grid item>
                                    <Link to={"/conteos_significativos"} target="_blank" rel="noreferrer" style={{color: '#000000', textDecoration: 'none'}}>
                                        <Button variant="contained" name="revision_tag_operador" color="primary">
                                            Conteos significativos</Button>
                                    </Link>
                                </Grid>
                                <Grid item>
                                    {this.state.existen_forzados ?
                                        <Link to={"/tags_avance/forzados/0/null"} target="_blank" rel="noreferrer" style={{color: '#000000', textDecoration: 'none'}}>
                                            <Button variant="contained" name="forzados" style={{backgroundColor:'#ffc400'}}>
                                                Ver forzados
                                            </Button>
                                        </Link>
                                        :
                                        <Button variant="contained" name="forzados" >
                                            Ver forzados
                                        </Button>}
                                </Grid>
                                <Grid item>
                                    <Link to={"/modificaciones"} target="_blank" rel="noreferrer" style={{color: '#000000', textDecoration: 'none'}}>
                                        <Button variant="contained" color="primary">
                                            Ver modificaciones
                                        </Button>
                                    </Link>
                                </Grid>
                                <Grid item>
                                    <Link to={"/eliminados"} target="_blank" rel="noreferrer" style={{color: '#000000', textDecoration: 'none'}}>
                                        <Button variant="contained" color="primary">
                                            Ver eliminados
                                        </Button>
                                    </Link>
                                </Grid>
                                <Grid item>
                                    {this.state.existen_duplicados ?
                                        <Link to={"/conflictos"} target="_blank" rel="noreferrer" style={{color: '#000000', textDecoration: 'none'}}>
                                            <Button variant="contained" name="forzados" style={{backgroundColor:'#ffc400'}}>
                                                Ver duplicados
                                            </Button>
                                        </Link>
                                        :
                                        <Button variant="contained" name="forzados" >
                                            Ver duplicados
                                        </Button>
                                    }
                                </Grid>
                            </>
                        }
                        {this.state.cliente === "walmart_flejes" &&
                            <>
                                <Grid item>
                                    <Link to={"/cantidades_revisar"} target="_blank" rel="noreferrer" style={{color: '#000000', textDecoration: 'none'}}>
                                        <Button variant="contained" name="revision_tag_operador" color="primary">
                                            Cantidades x revisar </Button>
                                    </Link>
                                </Grid>
                                <Grid item>
                                    <Button startIcon={ <SvgIcon>
                                        <path fill="currentColor" d="M6,2C4.89,2 4,2.9 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M13,3.5L18.5,9H13M8.93,12.22H16V19.29L13.88,17.17L11.05,20L8.22,17.17L11.05,14.35" />
                                    </SvgIcon>} variant="contained" name="avance" color="primary" onClick={() => this.enviarDatosReportes("flejes_duplicados")}>
                                        Felejes duplicados</Button>
                                </Grid>
                            </>
                        }
                        {this.state.cliente === 'easy_auditoria' &&
                            <Grid item>
                                <Button variant="contained" name="avance" color="primary" onClick={() => this.setState({open_auditoria:true})}>
                                    Auditoria estándar</Button>
                            </Grid>}

                        {this.state.cliente === "smu_perecible" &&
                            (<>
                                <Grid item>
                                    <Button variant="contained" name="avance" color="primary" onClick={() => this.setState({open_check_list:true})}>
                                        Check list</Button>
                                </Grid>
                                <Grid item>
                                    <Link to={"/validacion_conteo"} target="_blank" rel="noreferrer" style={{color: '#000000', textDecoration: 'none'}}>
                                        <Button variant="contained" color="primary">
                                            Validación conteo
                                        </Button>
                                    </Link>
                                </Grid>
                                <Grid item>
                                    <Button disabled={!this.state.verifica_correo_tienda || this.state.estado_inv !== 'cerrado'} variant="contained" name="avance" color="primary" onClick={() => this.setState({openCargarArchivos:true})}>
                                        Cargar documentos</Button>
                                </Grid>
                            </>)}
                        <Grid item>
                            <Button startIcon={ <SvgIcon>
                                <path fill="currentColor" d="M6,2C4.89,2 4,2.9 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M13,3.5L18.5,9H13M8.93,12.22H16V19.29L13.88,17.17L11.05,20L8.22,17.17L11.05,14.35" />
                            </SvgIcon>} variant="contained" name="avance" color="primary" onClick={() => this.enviarDatosReportes("avance")}>
                                Avance</Button>
                        </Grid>
                        <Grid item>
                            <Button startIcon={ <SvgIcon>
                                <path fill="currentColor" d="M6,2C4.89,2 4,2.9 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M13,3.5L18.5,9H13M8.93,12.22H16V19.29L13.88,17.17L11.05,20L8.22,17.17L11.05,14.35" />
                            </SvgIcon>} variant="contained" name="avance" color="primary" onClick={() => this.enviarDatosReportes("avance_por_zona")}>
                                Avance X Zona</Button>
                        </Grid>
                        {this.state.cliente === "ripley" &&
                            (<><Grid item>
                                <Button startIcon={ <SvgIcon>
                                    <path fill="currentColor" d="M6,2C4.89,2 4,2.9 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M13,3.5L18.5,9H13M8.93,12.22H16V19.29L13.88,17.17L11.05,20L8.22,17.17L11.05,14.35" />
                                </SvgIcon>} variant="contained" name="avance" color="primary" onClick={() => this.enviarDatosReportes("avance_por_piso")}>
                                    Avance X Piso</Button>
                            </Grid>
                            <Grid item>
                                <Button startIcon={ <SvgIcon>
                                    <path fill="currentColor" d="M6,2C4.89,2 4,2.9 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M13,3.5L18.5,9H13M8.93,12.22H16V19.29L13.88,17.17L11.05,20L8.22,17.17L11.05,14.35" />
                                </SvgIcon>} variant="contained" name="avance" color="primary" onClick={() => this.enviarDatosReportes("consignacion_inventariada_ripley")}>
                                    Consignacion inventariada</Button>
                            </Grid></>)}
                        {this.state.cliente !== 'smu_perecible' &&
                            <>
                                <Grid item>
                                    <Button startIcon={ <SvgIcon>
                                        <path fill="currentColor" d="M6,2C4.89,2 4,2.9 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M13,3.5L18.5,9H13M8.93,12.22H16V19.29L13.88,17.17L11.05,20L8.22,17.17L11.05,14.35" />
                                    </SvgIcon>}
                                            variant="contained" color="primary" name="tags_pendientes" onClick={() => this.enviarDatosReportes("tags_pendientes")}>
                                        Pendientes</Button>
                                </Grid>
                                <Grid item>
                                    <Button
                                        startIcon={ <SvgIcon>
                                            <path fill="currentColor" d="M6,2C4.89,2 4,2.9 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M13,3.5L18.5,9H13M8.93,12.22H16V19.29L13.88,17.17L11.05,20L8.22,17.17L11.05,14.35" />
                                        </SvgIcon>}
                                        variant="contained" name="tags_nulos" color="primary" onClick={() => this.enviarDatosReportes("tags_nulos")}>
                                        Nulos</Button>
                                </Grid>
                                <Grid item>
                                    <Button startIcon={ <SvgIcon>
                                        <path fill="currentColor" d="M6,2C4.89,2 4,2.9 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M13,3.5L18.5,9H13M8.93,12.22H16V19.29L13.88,17.17L11.05,20L8.22,17.17L11.05,14.35" />
                                    </SvgIcon>} variant="contained" name="avance" color="primary" onClick={() => this.enviarDatosReportes("capturas_simultaneas")}>
                                        Capturas simultáneas</Button>
                                </Grid>
                                <Grid item>
                                    <Button
                                        startIcon={ <SvgIcon>
                                            <path fill="currentColor" d="M6,2C4.89,2 4,2.9 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M13,3.5L18.5,9H13M8.93,12.22H16V19.29L13.88,17.17L11.05,20L8.22,17.17L11.05,14.35" />
                                        </SvgIcon>}
                                        variant="contained" name="resumen_bodega" color="primary" onClick={() => this.enviarDatosReportes("resumen_bodega")}>
                                        Resumen bodega</Button>
                                </Grid>
                                <Grid item>
                                    <Button
                                        startIcon={ <SvgIcon>
                                            <path fill="currentColor" d="M6,2C4.89,2 4,2.9 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M13,3.5L18.5,9H13M8.93,12.22H16V19.29L13.88,17.17L11.05,20L8.22,17.17L11.05,14.35" />
                                        </SvgIcon>}
                                        variant="contained" name="resumen_altillo" color="primary" onClick={() => this.enviarDatosReportes("resumen_altillo")}>
                                        Resumen altillo</Button>
                                </Grid>
                            </>
                        }
                        {(this.state.cliente === 'sodimac' || this.state.cliente === 'sodimac_auditoria') &&
                            <Grid item>
                                <Button startIcon={ <SvgIcon>
                                    <path fill="currentColor" d="M6,2C4.89,2 4,2.9 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M13,3.5L18.5,9H13M8.93,12.22H16V19.29L13.88,17.17L11.05,20L8.22,17.17L11.05,14.35" />
                                </SvgIcon>} variant="contained" name="auditoria_altillos" color="primary" onClick={() => this.enviarDatosReportes("auditoria_altillos")}>
                                    Auditoria altillos</Button>

                            </Grid>}
                        {(this.state.cliente === 'smu' || this.state.cliente === 'tottus') &&
                            <Grid item>
                                <Button
                                    startIcon={ <SvgIcon>
                                        <path fill="currentColor" d="M6,2C4.89,2 4,2.9 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M13,3.5L18.5,9H13M8.93,12.22H16V19.29L13.88,17.17L11.05,20L8.22,17.17L11.05,14.35" />
                                    </SvgIcon>}
                                    variant="contained" name="high_dollar" color="primary" onClick={() => this.enviarDatosReportes("high_dollar")}>
                                    high dollar</Button>
                            </Grid>}
                        {this.state.cliente === 'smu' &&
                            (<><Grid item>
                                <Button
                                    startIcon={ <SvgIcon>
                                        <path fill="currentColor" d="M6,2C4.89,2 4,2.9 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M13,3.5L18.5,9H13M8.93,12.22H16V19.29L13.88,17.17L11.05,20L8.22,17.17L11.05,14.35" />
                                    </SvgIcon>}
                                    variant="contained" name="high_dollar" color="primary" onClick={() => this.enviarDatosReportes("high_dollar_bodega")}>
                                    high dollar bodega</Button>
                            </Grid>
                                <Grid item>
                                    <Button
                                        startIcon={ <SvgIcon>
                                            <path fill="currentColor" d="M6,2C4.89,2 4,2.9 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M13,3.5L18.5,9H13M8.93,12.22H16V19.29L13.88,17.17L11.05,20L8.22,17.17L11.05,14.35" />
                                        </SvgIcon>}
                                        variant="contained" name="high_dollar" color="primary" onClick={() => this.enviarDatosReportes("low_dollar")}>
                                        low dollar</Button>
                                </Grid>
                                <Grid item>
                                    <Button
                                        startIcon={ <SvgIcon>
                                            <path fill="currentColor" d="M6,2C4.89,2 4,2.9 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M13,3.5L18.5,9H13M8.93,12.22H16V19.29L13.88,17.17L11.05,20L8.22,17.17L11.05,14.35" />
                                        </SvgIcon>}
                                        variant="contained" name="high_dollar" color="primary" onClick={() => this.enviarDatosReportes("low_dollar_bodega")}>
                                        low dollar bodega</Button>
                                </Grid>
                            <Grid item>
                                <Button
                                    startIcon={ <SvgIcon>
                                        <path fill="currentColor" d="M6,2C4.89,2 4,2.9 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M13,3.5L18.5,9H13M8.93,12.22H16V19.29L13.88,17.17L11.05,20L8.22,17.17L11.05,14.35" />
                                    </SvgIcon>}
                                    variant="contained" name="revision_tag_operador" color="primary" onClick={() => this.enviarDatosReportes("revision_tag_operador")}>
                                    Tag por operador</Button>
                            </Grid>
                            </>)}
                    </Grid>
                    <TablaAvanceVirtualizada 
                        datos={this.state.datos} 
                        setDatos={(datos) => this.setState({ datos })}
                        getHijos={(id) => avanceResources.getHgetAvanceUbicacionZona(id)}/>
                    {this.state.openSnack? <SnackbarAlert severity={this.state.severity} message={this.state.message}/> : null}
                    {this.state.open? <DialogExportar reporte={this.state.reporte} origen={this.state.origen} params={this.state.params} refrescar={this.refrescar} handleClose={this.handleClose}/> : null}
                    {this.state.open_auditoria && <DialogAuditoriaEstandar refrescar={this.refrescar} handleClose={this.handleClose}/>}
                    {this.state.open_check_list && <DialogCheckList refrescar={this.refrescar} handleClose={this.handleClose}/>}
                    {this.state.openCargarArchivos? <DialogCargarArchivos rowData={this.state.rowData} handleClose={this.handleClose} refrescar={this.refrescar}/>:null}
                </div>
            )
        }
    }
}

export default withRouter(Avance);